/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { visuallyHidden } from '@atlaskit/theme';

export const ScreenReadersOnly = styled.span`
  ${visuallyHidden()}
`;
